import React from 'react';
import styled from 'styled-components';
import { Grid } from '../../../app/StyleGuide';

type BroswerItemProps = {
  src: string;
  alt: string;
  title: string;
  link: string;
};

const BrowserItemDiv = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  min-width: 210px;
  margin-top: ${Grid._5};
`;

const BrowserIcon = styled.img`
  width: 50px;
  margin-bottom: ${Grid._4};
`;

export const BrowserItem = ({ src, alt, title, link }: BroswerItemProps) => {
  return (
    <BrowserItemDiv>
      <BrowserIcon src={src} alt={alt} />
      <strong>{title}</strong>
      <p>
        Supported
        <br />
        Versions:
      </p>
      <p>
        <em>Latest</em>
      </p>
      <p>
        <a href={link}>More Info</a>
      </p>
    </BrowserItemDiv>
  );
};
